import React from 'react'
import "./project1.css"
const Project1 = () => {
  return (
    <div className="haunt">
      <p className="pa2">
        <strong>Project 1:</strong> <br /><strong>TextUtils</strong> – Smart Text Utility
        Application TextUtils is a responsive React-based web application
        designed to enhance text readability and manipulation efficiency. It
        provides multiple text transformation and analysis features to improve
        user productivity.<br /><br />
        <strong>Key Features: </strong>Convert text to Uppercase and Lowercase
        Real-time Word and Character Count Estimated Reading Time calculation
        Live Preview Section for instant output visibility Integrated Dark and
        Light Mode for better user experience Fully Responsive UI <br /><br />
        <strong>Tech Stack:</strong> <br />
        React.js <br />
        JavaScript<br />
        HTML5 <br />
        CSS3<br /><br />
        <strong>Description:</strong> <br />
        This project demonstrates my understanding of React fundamentals,
        including state management, props handling, component structure, and
        dynamic rendering. The application focuses on usability, performance,
        and clean UI design. GitHub Link   
        <a href="http://github.com/Shu12123"><i className="fab fa-github fa-2x" style={{color:'white'}}></i></a>
        <br/><br/><strong>Project 2: Current Chronicle – Dynamic News Application</strong><br/>
        Current Chronicle is a modern news web application that fetches and
        displays real-time daily news updates using an external News API. It
        delivers categorized news content with a clean and interactive user
        interface. <br/><br/>
        <strong>Key Features:</strong> <br/>
        Fetches real-time news updates <br/>
        Category-based news browsing <br/>
        Dynamic content rendering using API integration <br/>
        Responsive and user-friendly design Loading indicators for
        better UX <br/><br/>
        <strong>Tech Stack: </strong>
        React.js <br/>
        JavaScript <br/>
        News API <br/>
        HTML5 <br/>
        CSS3 <br/><br/>
        <strong>Description:</strong><br/>This project highlights my ability to work with APIs,
        asynchronous JavaScript, and React lifecycle methods. It demonstrates
        skills in handling external data, managing application state, and
        building scalable front-end applications. 
        GitHub Link    <a href="http://github.com/Shu12123"><i className="fab fa-github fa-2x" style={{color:'white'}}></i></a>
      </p>
    </div>
  )
}

export default Project1
